export const LEAD_STATUS = {
    deliveryRequested: '5fbf6505e4073f744bae3a28',
    deliveryRequestedTrade: '60422adafdfc98e8de82c458',
    arrangeDelivery: '5c4837e08109b9f96e847a49',
    transportArranged: '5c8615197e203773e8886802',
    arrangeDeliveryTrade: '5f8574fcd88a9007b68aa736',
    transportArrangedTrade: '5f85820bd88a9007b68aa739',
    scrapBike: '5f8574ced88a9007b68aa734',
    doNotWantTrade: '5f7f248cf0c43201c2a7192c',
    pending: '5beabfe7f25bf5f49685abfb',
    pendingTrade: '5f8574a3d88a9007b68aa732',
    priced: '5c349213b01ff686c64b1dd4',
    priceGiven: '5beabfe7f25bf5f49685abfc',
    customerAccepted: '5beac00ef25bf5f49685abfd',
    inProgress: '5bf2b498f83650911c3e3e80',
    inProgressTrade: '5f85823bd88a9007b68aa73a',
    collectionCancelled: '5c87845747f99d83281b350c',
    collectionCancelledTrade: '5f858829d88a9007b68aa73c',
    customerCancelledAlreadySoldBike: '5beac062f25bf5f49685abff',
    customerAlreadySoldTrade: '5f885dc8d88a9007b68aa73f',
    customerCancelledOfferedBetterPriceElsewhere: '5beac062f25bf5f49685ac00',
    customerChangedMind: '5beac063f25bf5f49685ac02',
    customerWantsTooMuch: '5beac063f25bf5f49685ac01',
    customerWantsTooMuchTrade: '5f85a3ead88a9007b68aa73d',
    doNotContact: '5cc1a18319c64e49ff8b13d8',
    awaitingV5: '616976d5aad9ab9a0b148910',
    triedToCallWrongNumber: '5beac063f25bf5f49685ac04',
    triedToCallNoAnswer: '5beac063f25bf5f49685ac03',
    triedToCallNoAnswerTrade: '5f886009d88a9007b68aa740',
    damagedBike: '5beabf6166676f89160edfc7',
    hpiFailure: '5beabe6d66676f89160edd7f'
};

export const LEAD_CANCELLATION_STATUSES = [
    LEAD_STATUS.customerCancelledAlreadySoldBike,
    LEAD_STATUS.customerCancelledOfferedBetterPriceElsewhere,
    LEAD_STATUS.customerWantsTooMuch,
    LEAD_STATUS.customerChangedMind,
    LEAD_STATUS.triedToCallWrongNumber,
    LEAD_STATUS.triedToCallNoAnswer,
    LEAD_STATUS.collectionCancelled,
    LEAD_STATUS.collectionCancelledTrade,
];



// WEBPACK FOOTER //
// ./src/modules/Leads/constants/leadStatuses.js